import { http } from '@/lib/http';
import type { DashboardOverview } from '@/types/dashboard';

const BASE = '/api/v1/dashboard';

export const dashboardService = {
  overview: () => http.get<DashboardOverview>(BASE),
};
